// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/SFPRODISPLAYREGULAR.OTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'SF Pro Display';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

.navbar_mobile_navbar__qpJVL {
    background-color: white;
}

.navbar_burgerButton__V5Ypg{
    display: none;
}

.navbar_logo__YptKc {
    display: none
}

.navbar_searchOpener__-BA38 {
    display: none;
}

.navbar_doropdownnavmenu__FXBI6 {
    display: flex;
    flex-direction: column;
}

.navbar_shopDetailsImg__Aurqt{
    display: none;
}

@media screen and (min-width: 770px) {
    .navbar_mobile_navbar__qpJVL{
        justify-content: flex-end;
    }

    .navbar_dropDownPosition__0FhtR{
        width: 100% !important;
        left: auto ;
        right: -12px !important;
    }

    .navbar_bottomPadding__\\+YCRm{
        padding-bottom: 10px;
        /* text-align: center; */
    }
}

@media screen and (max-width: 768px) {
    .navbar_plus__TWi1g{
        position: static !important;
    }
    .navbar_mobile_navbar__qpJVL {
        background-color: #0094ff;
        height: 45px;
        display: flex;
        justify-content: space-between;
    }

    .navbar_burgerButton__V5Ypg, .navbar_shopDetailsImg__Aurqt{
        display: block;
    }

    .navbar_logo__YptKc {
        display: block;
        color: white;
        font-weight: 500;
        font-size: 15px;
        line-height: 17px;
        font-family: 'SF Pro Display';
        margin: 0 auto
    }

    .navbar_logo__YptKc img {
        width: 30px;
        margin-right: 4px;
    }

    .navbar_searchOpener__-BA38 {
        display: block;
        font-size: 30px;
        color: white;
    }


    .navbar_dropdownimg__boexN {
        display: none;
    }

    .navbar_doropdownnavmenu__FXBI6 {
        flex-direction: row !important;
        height: 80px;
        background-color: #006ed6;
        font-size: 27px;
        justify-content: center;
        align-items: center;
        gap: 74px;
    }

    .navbar_doropdownnavmenu__FXBI6 i {
        font-size: 26px !important;
        color: white !important;
    }

    .navbar_doropdownnavmenu__FXBI6 span {
        display: none;

    }



}

@media screen and (max-width: 560px){
    .navbar_doropdownnavmenu__FXBI6{
        gap: 14px;
    }
}


@media screen and (max-width: 330px) {
    .navbar_logo__YptKc {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 9px;
        font-size: 13px;

    }

    .navbar_logo__YptKc img {
        width: 35px;
    }

    .navbar_doropdownnavmenu__FXBI6{
        gap: 1px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/thememaker/navbar/navbar.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAqE;IACrE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;QACpB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,6BAA6B;QAC7B;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,YAAY;QACZ,yBAAyB;QACzB,eAAe;QACf,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,aAAa;;IAEjB;;;;AAIJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;;AAGA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,eAAe;;IAEnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;AAEJ","sourcesContent":["@font-face {\n    font-family: 'SF Pro Display';\n    src: url('../../../fonts/SFPRODISPLAYREGULAR.OTF') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n.mobile_navbar {\n    background-color: white;\n}\n\n.burgerButton{\n    display: none;\n}\n\n.logo {\n    display: none\n}\n\n.searchOpener {\n    display: none;\n}\n\n.doropdownnavmenu {\n    display: flex;\n    flex-direction: column;\n}\n\n.shopDetailsImg{\n    display: none;\n}\n\n@media screen and (min-width: 770px) {\n    .mobile_navbar{\n        justify-content: flex-end;\n    }\n\n    .dropDownPosition{\n        width: 100% !important;\n        left: auto ;\n        right: -12px !important;\n    }\n\n    .bottomPadding{\n        padding-bottom: 10px;\n        /* text-align: center; */\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .plus{\n        position: static !important;\n    }\n    .mobile_navbar {\n        background-color: #0094ff;\n        height: 45px;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .burgerButton, .shopDetailsImg{\n        display: block;\n    }\n\n    .logo {\n        display: block;\n        color: white;\n        font-weight: 500;\n        font-size: 15px;\n        line-height: 17px;\n        font-family: 'SF Pro Display';\n        margin: 0 auto\n    }\n\n    .logo img {\n        width: 30px;\n        margin-right: 4px;\n    }\n\n    .searchOpener {\n        display: block;\n        font-size: 30px;\n        color: white;\n    }\n\n\n    .dropdownimg {\n        display: none;\n    }\n\n    .doropdownnavmenu {\n        flex-direction: row !important;\n        height: 80px;\n        background-color: #006ed6;\n        font-size: 27px;\n        justify-content: center;\n        align-items: center;\n        gap: 74px;\n    }\n\n    .doropdownnavmenu i {\n        font-size: 26px !important;\n        color: white !important;\n    }\n\n    .doropdownnavmenu span {\n        display: none;\n\n    }\n\n\n\n}\n\n@media screen and (max-width: 560px){\n    .doropdownnavmenu{\n        gap: 14px;\n    }\n}\n\n\n@media screen and (max-width: 330px) {\n    .logo {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 9px;\n        font-size: 13px;\n\n    }\n\n    .logo img {\n        width: 35px;\n    }\n\n    .doropdownnavmenu{\n        gap: 1px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile_navbar": `navbar_mobile_navbar__qpJVL`,
	"burgerButton": `navbar_burgerButton__V5Ypg`,
	"logo": `navbar_logo__YptKc`,
	"searchOpener": `navbar_searchOpener__-BA38`,
	"doropdownnavmenu": `navbar_doropdownnavmenu__FXBI6`,
	"shopDetailsImg": `navbar_shopDetailsImg__Aurqt`,
	"dropDownPosition": `navbar_dropDownPosition__0FhtR`,
	"bottomPadding": `navbar_bottomPadding__+YCRm`,
	"plus": `navbar_plus__TWi1g`,
	"dropdownimg": `navbar_dropdownimg__boexN`
};
export default ___CSS_LOADER_EXPORT___;
